import ColorfulSearchbar from './colorful-searchbar';
export default ColorfulSearchbar;
